import {Record} from 'immutable';
import moment from 'moment-timezone';

import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

export const DepositStatus = {
    PENDING: 'PENDING',
    INVOICED: 'INVOICED',
    PAID_EXTERNALLY: 'PAYED_EXTERNALLY',
};

const Deposit = Record({
    depositId: '',
    childId: '',
    billPayerId: '',
    amount: null,
    date: null,
    note: '',
    returned: null,
    createdAt: '',
    status: '',
    behaviors: new BehaviorsCollection([]),
});

const Return = Record({
    returnId: '',
    status: '',
    createdAt: '',
    behaviors: new BehaviorsCollection([]),
});

const fromAPI = response => {
    return new Deposit({
        depositId: response.depositId,
        childId: response.childId,
        billPayerId: response.billPayerId,
        amount: response.amount,
        date: moment(response.date),
        createdAt: moment(response.createdAt),
        status: response.status,
        note: response.note,
        behaviors: response.behaviors ? new BehaviorsCollection(response.behaviors) : new BehaviorsCollection([]),
        returned: response.return
            ? new Return({
                  behaviors: response.return.behaviors
                      ? new BehaviorsCollection(response.return.behaviors)
                      : new BehaviorsCollection([]),
                  returnId: response.return.returnId,
                  status: response.return.status,
                  createdAt: moment(response.return.createdAt),
              })
            : null,
    });
};

const toAPI = deposit => {
    return {
        note: deposit.note,
        amount: deposit.amount,
        date: deposit.date.format('YYYY-MM-DD'),
        status: deposit.status,
    };
};

const fromFormData = formData => {
    return new Deposit({
        depositId: null,
        childId: null,
        amount: parseFloat(formData.amount),
        date: moment(formData.date, 'YYYY-MM-DD'),
        note: formData.note,
        status: formData.alreadyPaid ? 'PAID_EXTERN' : '',
    });
};

const toFormData = deposit => {
    return {
        amount: deposit.amount,
        billPayerId: deposit.billPayerId,
        date: deposit.date && deposit.date.format('YYYY-MM-DD'),
        returnDate: deposit.returned && moment(deposit.returned.createdAt).format('YYYY-MM-DD'),
        alreadyPaid: deposit.status === DepositStatus.PAID_EXTERNALLY,
        note: deposit.note,
    };
};

export default {
    Status: DepositStatus,
    record: Deposit,
    fromAPI,
    toAPI,
    fromFormData,
    toFormData,
};
